import React from 'react';
import { Link } from 'react-router-dom';
import LegalDocument from './LegalDocument';
import { PRIVACY } from './privacy';
import { TERMS } from './terms';
import './LegalPage.css';

const DOCS = { privacy: PRIVACY, terms: TERMS };

/**
 * Public — mounted outside RequireAuth. Apple's reviewers and anyone deciding whether to
 * accept at onboarding must be able to read these without an account.
 */
const LegalPage = ({ doc }) => {
  const document = DOCS[doc];
  return (
    <div className="legal-page">
      <div className="legal-page-inner">
        <header className="legal-page-head">
          <h1>{document.title}</h1>
          <p className="legal-page-meta">
            버전 {document.version} · 시행일 {document.effectiveDate}
          </p>
        </header>
        <LegalDocument doc={document} />
        <nav className="legal-page-nav">
          <Link to={doc === 'privacy' ? '/terms' : '/privacy'}>
            {doc === 'privacy' ? '이용약관' : '개인정보처리방침'}
          </Link>
        </nav>
      </div>
    </div>
  );
};

export default LegalPage;
